import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { find, first, get, isEmpty, has, some } from 'lodash';
import { isTeacher, isTeachersEnabled } from 'utils/authScopes';

const getAnswer = (response, path, entities) => {
  const answerId = get(response, path);
  if (!answerId) return null;
  const answer = first(entities.answers[answerId].answerHandles);
  return find(response.possibleAnswers, { handle: answer });
}

export default class PlayerQuestion extends React.PureComponent {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    entities: PropTypes.object.isRequired,
    teacherSurvey: PropTypes.object,
    qIdx: PropTypes.number.isRequired,
    question: PropTypes.object.isRequired,
    onQuestionInfo: PropTypes.func.isRequired,
    onClickNotes: PropTypes.func.isRequired,
  }

  onClick = (_e) => {
    this.props.onQuestionInfo(this.props.question.id);
  }

  onClickNotes = () => {
    this.props.onClickNotes(this.props.question.id, this.props.qIdx + 1, !isEmpty(this.props.question.notesIds));
  }

  render() {
    const { auth, entities, question, qIdx, teacherSurvey } = this.props;
    const showTeacher = isTeachersEnabled(auth);
    const responseId = find(question.responseTypes, r => entities.responseTypes[r].required);
    const response = responseId ? entities.responseTypes[responseId] : null;
    const parentKey = has(response, 'answer.parent') ? 'answer.parent' : 'answer';
    const parentAnswer = responseId ? getAnswer(response, parentKey, entities) : null;
    const teacherAnswer = responseId && showTeacher ? getAnswer(response, 'answer.teacher', entities) : null;
    const hasAnsweredDetails = (r) => r.inputType !== 'radio' && (get(r, parentKey) || get(r, 'answer.teacher'));
    const withDetails = some(question.responseTypes, r => hasAnsweredDetails(entities.responseTypes[r]));
    const clsRadio = classNames('o-player-section__radio',
      { 'cs-bg--sp-gray': parentAnswer === teacherAnswer },
      { 'cs-bg--sp-diff': parentAnswer !== teacherAnswer },
    );
    const clsNotes = classNames('o-player-section__notes u-pointer',
      { 'cs-bg--sp-yellow': !isEmpty(question.notesIds) }
    );
    const bShowNotes = !isTeacher(auth) || teacherSurvey;
    return (
      <div className='o-player-question o-rtable__row o-rtable__row--bt-bordered'>
        <div className='o-player-cell o-player-cell__header'>
          <div className='u-flex-inline'>
            <span className='o-player-section__icon'></span>
            <span className='o-question__number'>{qIdx + 1}</span>
            <div className='u-margin-left--small'>
              <b>{question.boldBody}</b>
              { withDetails && <i className='u-margin-left--small u-pointer sp-icon-info cs-txt--sp-blue u-txt--player-info' onClick={this.onClick}></i> }
              { question.body && <p className='u-margin-bottom--zero'>{question.body}</p> }
              { question.imageUrl &&
                <div className='o-question__image text-center u-margin-top--small'>
                  <img alt='' src={question.imageUrl}></img>
                </div> }
            </div>
          </div>
        </div>
        <div className='o-player-cell o-player-cell__radio'>
          { showTeacher && teacherAnswer && <span className={clsRadio}>{teacherAnswer.label}</span> }
        </div>
        <div className='o-player-cell o-player-cell__radio'>
          { parentAnswer && <span className={clsRadio}>{parentAnswer.label}</span> }
        </div>
        <div className='o-player-cell o-player-cell__align'>
          { bShowNotes &&
            <span className={clsNotes} onClick={this.onClickNotes}>
              <i className='sp-icon-list'></i>
            </span> }
        </div>
      </div>
    );
  }
}
